import { AnnouncementCategoriesType, AnnouncementContentType } from '@va/types/announcements';
import { merge } from 'lodash';

export class Announcement {
  public categories;
  public id;
  public content;
  public active;

  constructor(
    id: string,
    categories: AnnouncementCategoriesType,
    content: AnnouncementContentType,
    active: boolean = true,
  ) {
    this.id = id;
    this.categories = categories;
    this.content = content;
    this.active = active;
  }
}

export class EmptyAnnouncement extends Announcement {
  constructor() {
    const id = '';
    const categories = {
      platform: '',
      subscriptionType: '',
      userType: '',
      installDate: '',
      numberOfMonthlyVisits: '',
      hadFirstVisit: null,
      hadFirstLogin: null,
      geolocation: '',
      messageType: '',
    };
    const content: AnnouncementContentType = {
      image: '',
      headline: '',
      text: '',
      confirmation_text: '',
      button_ok_text: '',
      button_cancel_text: '',
      confirmation_needed: false,
      target_url: '',
      target_url_raw: '',
      target_url_internal: '',
      internal_t3_link: null,
      internal_t3_link_utm: '',
      voucher_code: null,
      video: null,
      show_newsletter_toggle: false,
      show_email_reports_toggle: false,
    };
    super(id, categories, content);
  }
}

export const getDummyAnnouncement = (data?: {
  id?: string;
  categories?: Partial<AnnouncementCategoriesType>;
  content?: Partial<AnnouncementContentType>;
}) => {
  return merge(new EmptyAnnouncement(), data);
};

export const getDummyCategories = (data?: Record<any, any>) => {
  return {
    platform: 's',
    subscriptionType: '',
    userType: '',
    installDate: '',
    numberOfMonthlyVisits: '',
    hadFirstVisit: null,
    hadFirstLogin: null,
    geolocation: '',
    messageType: '',
    ...data,
  };
};

const accountBasedCategories = {
  platform: 'all',
  subscriptionType: 'all',
  userType: 'all',
};

const websiteBasedCategories = {
  platform: 'standalone, wix, wixminiapp',
  subscriptionType: 'free, premium',
  userType: 'owner',
};

const firstLoginCategories = {
  messageType: 'firstlogin',
  userType: 'all',
};

export const dummyAnnouncements = [
  getDummyAnnouncement({
    categories: accountBasedCategories,
    id: String(Math.random()),
    content: {
      video: {
        url: 'https://www.youtube.com/watch?v=KLuTLF3x9sA&pp=ygUINGsgdmlkZW8%3D',
        poster:
          'https://i.ytimg.com/vi/KLuTLF3x9sA/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLDEhqedzZVrESkMmuNTn20h3bRljA',
      },
      show_newsletter_toggle: true,
      show_email_reports_toggle: true,
      headline: 'Account based announcement',
      text: `Account based 1. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.

      Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.

      <ul>
        <li>List item 1</li>
        <li>List item 2</li>
        <li>List item 3</li>
      </ul>

      Integer in enim neque volutpat ac tincidunt vitae semper quis lectus. Aenean sed adipiscing diam donec adipiscing tristique risus nec feugiat in fermentum posuere urna. Nunc sed blandit libero volutpat sed cras ornare arcu dui vivamus. Eget nunc scelerisque viverra mauris in aliquam sem fringilla ut. Amet consectetur adipiscing elit duis tristique sollicitudin nibh sit amet. Eget nunc scelerisque viverra mauris in aliquam sem fringilla ut morbi tincidunt augue interdum velit euismod in pellentesque massa.`,
      image:
        'https://images.unsplash.com/photo-1744265385437-8b591b626a8b?q=80&w=764&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      button_cancel_text: 'Cancel',
    },
  }),
  getDummyAnnouncement({
    categories: accountBasedCategories,
    id: String(Math.random()),
    content: { text: 'Account based 2' },
  }),
  getDummyAnnouncement({
    categories: accountBasedCategories,
    id: 'id-3333333',
    content: { text: 'Account based 3' },
  }),
  getDummyAnnouncement({
    categories: accountBasedCategories,
    id: 'id-44444',
    content: { text: 'Account based 4' },
  }),

  getDummyAnnouncement({
    categories: websiteBasedCategories,
    id: String(Math.random()),
    content: { text: 'Website based 1' },
  }),
  getDummyAnnouncement({
    categories: websiteBasedCategories,
    id: String(Math.random()),
    content: { text: 'Website based 2' },
  }),
  getDummyAnnouncement({
    categories: websiteBasedCategories,
    id: 'id-777777777',
    content: { text: 'Website based 3' },
  }),
  getDummyAnnouncement({
    categories: firstLoginCategories,
    id: String(Math.random()),
    content: { text: 'First login' },
  }),
];
